/* eslint-disable @typescript-eslint/indent */

/* Note: please be careful with indentation, we have the rule disabled because of
*  eslint not being able to properly indent js inside styled components
*/

// Libraries
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
`;

export const ContentContainer = styled.div`
  display: flex;
  height: 100%;
`;

export const LeftPanel = styled.div`
  max-width: 500px;
  min-width: 30%;
  display: flex;
`;

export const RightPanel = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const SensorStatusContainer = styled.div`
  border-radius: 4px 0 0 4px;
  width: 100%;
  padding: 20px;
  border-top: 1px solid ${({
    theme,
  }) => theme.color.crusherDashboard.maintenance.comboUnit.sensors.borderColor};
  border-bottom: 1px solid ${({
    theme,
  }) => theme.color.crusherDashboard.maintenance.comboUnit.sensors.borderColor};
  border-left: 1px solid ${({
    theme,
  }) => theme.color.crusherDashboard.maintenance.comboUnit.sensors.borderColor};
`;

export const SensorStatusTitle = styled.div`
  margin: 0 0 16px 0;
`;

export const SensorItem = styled.div<{
  hasWarning?: boolean;
  hasAlarm?: boolean;
  isRunning?: boolean;
}>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;

  /* Helper function to determine border color based on sensor status */
  border-bottom: 1px solid ${({
    theme,
    hasWarning,
    hasAlarm,
    isRunning,
  }) => {
    // If edge device is disconnected and sensor has active thresholds, use neutral color
    if (!isRunning && (hasAlarm || hasWarning)) {
      return theme.color.crusherDashboard.maintenance.comboUnit.sensors.itemBorderColor;
    }

    // Apply threshold-based colors
    if (hasAlarm) {
      return theme.color.crusherDashboard.maintenance.comboUnit.alarmBorderColor;
    }
    if (hasWarning) {
      return theme.color.crusherDashboard.maintenance.comboUnit.warningBorderColor;
    }

    // Default border color
    return theme.color.crusherDashboard.maintenance.comboUnit.sensors.itemBorderColor;
  }};
  
  
  /* Apply background color based on sensor status */
  background-color: ${({
    theme,
    hasWarning,
    hasAlarm,
    isRunning,
  }) => {
    // If edge is off and sensor has active thresholds, apply neutral background
    if (!isRunning && (hasAlarm || hasWarning)) {
      return theme.color.crusherDashboard.maintenance.comboUnit.neutralBackgroundColor;
    }

    // Apply threshold-based colors
    if (hasAlarm) {
      return theme.color.crusherDashboard.maintenance.comboUnit.alarmBackgroundColor;
    }
    if (hasWarning) {
      return theme.color.crusherDashboard.maintenance.comboUnit.warningBackgroundColor;
    }

    // Default background color
    return theme.color.crusherDashboard.maintenance.comboUnit.sensors.backgroundColor;
  }};
  
  /* Add visual tolerance zone to prevent rapid hover switching */
  position: relative;
  
  /* Apply hover effects with appropriate colors for each status */
  &:hover {
    z-index: 1;

    /* Text color based on sensor status - apply to all text elements */
    > div > p:not(.not-hover-tag) {
      transition: color 0.3s ease-in-out;
      color: ${({
        theme,
        hasWarning,
        hasAlarm,
        isRunning,
    }) => {
        if (!isRunning) {
          return theme.color.crusherDashboard.maintenance.comboUnit.sensors.itemHoverTextColor;
        }
        if (hasAlarm) {
          return theme.color.crusherDashboard.maintenance.comboUnit.sensors.itemHoverAlarmTextColor;
        }
        if (hasWarning) {
          return theme.color.crusherDashboard.maintenance.comboUnit.sensors.itemHoverWarnTextColor;
        }
        return theme.color.crusherDashboard.maintenance.comboUnit.sensors.itemHoverTextColor;
      }};
    };
  };
`;

export const SensorName = styled.div`
  padding-left: 12px;
  color: ${({ theme }) => theme.color.crusherDashboard.maintenance.comboUnit.sensors.titleColor};
`;

export const SensorValue = styled.div`
  padding-right: 12px;
  color: ${({ theme }) => theme.color.crusherDashboard.maintenance.comboUnit.sensors.titleColor};
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ComboUnitImageContainer = styled.div`
  border-radius: 0 4px 4px 0;
  position: relative;
  border: 1px solid ${({
    theme,
  }) => theme.color.crusherDashboard.maintenance.comboUnit.sensors.imageContainerBorderColor};
  width: 100%;
  height: 100%;
  padding: 20px;
  background: ${({
    theme,
  }) => theme.color.crusherDashboard.maintenance.comboUnit.sensors.imageContainerBackgroundColor};
`;

export const ComboUnitImageStyled = styled.img<{ isHovered: boolean }>`
  width: 100%;
  flex: 1;
  align-items: center;
  justify-content: center;
  object-fit: scale-down;
  height: calc(100vh - 300px);
  transition: all 0.3s ease;
  transform: ${({ isHovered }) => (isHovered ? 'scale(1.02)' : 'scale(1)')};
  filter: ${({ isHovered }) => (isHovered ? 'brightness(1.05)' : 'brightness(1)')};
  opacity: ${({ isHovered }) => (isHovered ? 1 : 0)};
  pointer-events: none;
  position: absolute;
  inset: 0;
`;
